/*
    * Marionette LayoutView: TopNavView
    * -------------------------
    * Representative of the top nav bar - takes care of rendering that properly
*/
import _ from 'underscore';
import Radio from 'backbone.radio';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import $ from 'jquery';
import Devices from '@/collections/v5/devices';
import ItemLookup from '@/views/item_lookup';
import StatusDropdownView from '@/views/status_dropdown_view';
import NotificationDropdownView from '@/views/notification_dropdown_view';
import PreviewPopover from '@/views/preview_popover';
import strings from 'amdi18n-loader!@/nls/top_nav';
import template from '@/../templates/top-nav.hbs';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

var TopNavView = Marionette.View.extend({
    template: Handlebars.compile(template),
    lastIdeView: '/ide',
    regions: {
        statusDropdown : 'ul.status',
        notificationDropdown : '@ui.notification_dropdown',
        device_lookup: '@ui.device_lookup',
        device_search_results: '@ui.device_search_results',
        devicegroup_lookup: '@ui.devicegroup_lookup',
        devicegroup_search_results: '@ui.devicegroup_search_results',
        feedback: '@ui.feedback',
    },
    ui : {
        nav_links: '.nav > div > a',
        logout : '.logout',
        profile : '#profile',
        collaborations: '#collaborations',
        settings_menu_invite_user : '#settings-menu-invite-user',
        logo : '.logo',
        dropdowns : '.dropdown-toggle',
        account_change : '.account-change a',
        account_change_text : '.account-change a .name',
        account_change_menu : '.account-change > .menu',
        status_count: '.status .count',
        devices_primary: '.devices.primary > a',
        device_lookup: '.devices-menu .device-lookup',
        device_search_results: '.devices-menu .device-search-results',
        devicegroup_lookup: '.devicegroup-lookup',
        devicegroup_search_results: '.devicegroup-search-results',
        preview_popover: '.preview-popover',
        new_world_carousel_link: '.new-world-carousel-link',
        logo_image: '.logo .logo-image',
        blinkup_device: '.blinkup-device',
        notification_dropdown: '.notification-dropdown',
        feedback: '.feedback',
    },
    events: {
        'click @ui.profile': 'show_profile_primary',
        'click @ui.collaborations': 'show_collaborations',
        'click @ui.settings_menu_invite_user': 'openInviteUserDialog',
        'click @ui.logout': 'doLogout',
        'click @ui.logo_image': 'home',
        'click @ui.devices_primary': 'show_primary_devices_list',
        'click @ui.blinkup_device': 'show_blinkup_page',
        'click @ui.preview_popover': 'preview_popover', // feature to send users to preview server for products
        'click @ui.new_world_carousel_link': function(e){
            e.preventDefault();
            globalCh.request('showNewUserImpCentralCarousel');
        },
    },
    className : 'flex-container',
    set_active: function(selection) {
        this.ui.nav_links.removeClass('active');
        if (selection &&
                selection.type === 'app' &&
                selection.id === 'devices') {
            this.ui.devices_primary.addClass('active');
        }
    },
    templateContext: function() {
        var helpers = {
            serverStatus: true,
            documentationTab: true,
            forumsTab: true,
            show_version_info: false,
            show_tos_and_privacy: true,
            environment_name: false,
            preview_environment_url: false,
            version_info: false,
            powered_by: false,
            s: strings,
        };

        var app_options = globalCh.request('app_options');

        if (app_options.features) {
            _.extend(helpers, app_options.features);
        }
        return helpers;
    },
    render_device_search_results: function(resp) {
        let devices = new Backbone.Collection(resp.devices);
        let device_view = Marionette.View.extend({
            tagName: 'a',
            className: 'device small device-link',
            attributes: function(){
                return {
                    'href' : `/ide/devices/${this.model.get('i')}`,
                    'data-type': this.model.get('t')
                };
            },
            template: Handlebars.compile(`{{i}}<br />{{#if name}}{{name}}<br />{{/if}}{{t}}`),
            templateContext: function(){
                let name =  this.model.get('n');
                if ( name && name.length > 20 ) {
                    name = name.substring(0, 25);
                }
                return { 'name' : name };
            },
            onRender: function() {
                this.$el.attr('data-id', 'device-search-result'+ this.model.get('i'));
            },
            events: {
                'click': function(e) {
                    if (e.which === 1) {
                        this.show_device(this.model.get('i'));
                        return false;
                    }
                }
            },
            show_device: function (device_id) {
                var device = apiCh.request('device');

                function success(device) {
                    globalCh.request('show_device', device);
                }
                function error() {
                    globalCh.request('not_found', "Couldn't find device " + device_id);
                }
                device.lookup(device_id)
                    .done(success)
                    .fail(error);
            },

        });
        this.showChildView('device_search_results', new Marionette.CollectionView({
                className: 'device-results',
                template: Handlebars.compile( '<div><h6>'+devices.length + ' devices match out of ' + resp.count + '</h6></div><ul class="results"></ul>'),
                collection: devices,
                childView: device_view,
                childViewContainer: 'ul.results',
            })
        );
    },
    render_devicegroup_search_results: function(resp) {
        let devicegroups = new Backbone.Collection(resp.devicegroups);
        let devicegroups_view = Marionette.View.extend({
            tagName: 'a',
            className: 'device small device-link',
            attributes: function(){
                return {
                    'href' : `/ide/devicegroup/${this.model.get('i')}`,
                    'data-type': this.model.get('t')
                };
            },
            template: Handlebars.compile(`{{i}}<br />{{#if name}}{{name}}<br />{{/if}}{{t}}`),
            templateContext: function(){
                let name =  this.model.get('n');
                if ( name && name.length > 20 ) {
                    name = name.substring(0, 25);
                }
                return { 'name' : name };
            },
            onRender: function() {
                this.$el.attr('data-id', 'devicegroup-search-result'+ this.model.get('i'));
            },
            events: {
                'click': function(e) {
                    if (e.which === 1) {
                        this.show_devicegroup(this.model);
                        return false;
                    }
                }
            },
            show_devicegroup: function (search_model) {
                var devicegroup = apiCh.request('development_devicegroup');

                function success(devicegroup) {
                    if ( devicegroup.type === 'development_devicegroup' || devicegroup.type.indexOf('pre') > -1 ) {
                        var draft = devicegroup.draft;
                        if ( draft.get('id') ) {
                            draft.fetch().then(
                                function(){
                                    globalCh.request('showCodeEditor', draft, devicegroup);
                                },
                                function(err){
                                    if ( devicegroup.rel.get('current_deployment') ) {
                                        globalCh.request('showCodeEditor', devicegroup.rel.get('current_deployment'), devicegroup);
                                    } else {
                                        globalCh.request('showCodeEditor', draft, devicegroup);
                                    }
                                });
                        } else {
                            if ( devicegroup.rel.get('current_deployment') ) {
                                globalCh.request('showCodeEditor', devicegroup.rel.get('current_deployment'), devicegroup);
                            } else {
                                globalCh.request('showCodeEditor', draft, devicegroup);
                            }
                        }
                    } else {
                        globalCh.request('show_devicegroup_dashboard', devicegroup);
                    }
                }
                function error() {
                    globalCh.request('not_found', "Couldn't find device " + search_model.get('i'));
                }
                devicegroup.lookup(search_model.get('i'))
                    .done(success)
                    .fail(error);
            },

        });
        this.showChildView('devicegroup_search_results', new Marionette.CollectionView({
                className: 'devicegroup-results',
                template: Handlebars.compile( '<div><h6>'+devicegroups.length + ' devices match out of ' + resp.count + '</h6></div><ul class="results"></ul>'),
                collection: devicegroups,
                childView: devicegroups_view,
                childViewContainer: 'ul.results',
            })
        );
    },
    onRender: function() {
        var self = this;
        this.ui.dropdowns.dropdown();
        const Notifications = apiCh.request('notification');
        Notifications.on('add change', this.count); // this updates the collection with new count
        Notifications.fetch();

        this.ui.devices_primary.tooltip({
            html: true,
            delay: { 'show': 500, 'hide': 100 },
            title: function() {
                var title = 'Devices';
                // if (self.unassigned_devices_primary_count > 0) {
                //     title += '<div style="white-space:nowrap">(' + self.unassigned_devices_primary_count + ' unassigned)</span>';
                // }
                return title;
            }
        });

        if ( globalCh.request('app_options', 'environment_name') ) {
            this.ui.logo.addClass( globalCh.request('app_options', 'environment_name') );
        }

        if ( globalCh.request('app_options', 'version_info') ) {
            Radio.request('global', 'addVersionInfoPopover', this.ui.logo.find('a'));
        }

        if ( globalCh.request('app_options', 'show_preview_popover') ){
            this.add_preview_popover();
        }

        let DeviceGroups = apiCh.request('development_devicegroup');
        this.showChildView('devicegroup_lookup', new ItemLookup({
            className: 'menu-item',
            collection: DeviceGroups,
            title: 'Device Group Lookup',
            placeholder: 'Group ID, Name',
            autocomplete: 'off',
            action: function(resp) {
                self.render_devicegroup_search_results(resp, 'devicegroup');
            },
            fail: function(err) {
                self.render_devicegroup_search_results(false, 'devicegroup');
            }
        }));

        this.showChildView('device_lookup', new ItemLookup({
            className: 'menu-item',
            collection: Devices,
            title: 'Device Lookup',
            placeholder: 'Device ID, MAC address, Agent ID',
            autocomplete: 'off',
            action: function(resp) {
                self.render_device_search_results(resp, 'device');
            },
            fail: function() {
                self.render_device_search_results(false, 'device');
            }
        }));
        // =======================
        // Begin old onShow method
        // =======================

        var app_options = globalCh.request('app_options');
        // var active_account = globalCh.request('active_account');

        globalCh.on('selection', this.set_active, this);

        // Listen for new devices, changes to model_id, and device deletion
        // this.listenTo(active_account.devices, 'update change:model_id destroy', this.updateUnassignedDevicesCount);
        // this.updateUnassignedDevicesCount();

        /*
            * Show the server status feature? Right now
            * right now, it is set to look for false, which
            * is sort of cute. Maybe worth updating the
            * globalCh's app_options request to be able to
            * determine false. For more details search:
            *       setHandler('app_options
            */

        if ( app_options.features && app_options.features.serverStatus !== false ) {
            var status_view = new StatusDropdownView();
            this.listenTo(status_view, 'update_count', this.updateStatusCount);
            this.showChildView('statusDropdown', status_view);
        }

        /*
            * Google Analytics (GA) Integration
            * Pass a pageview event if there is a ga_account
            * specified in the config. We don't attempt to
            * validate this at all beforehand. If you get an
            * error from GA, then, check the account id
            * passed from the config.
            */
        if ( globalCh.request('app_options', 'ga_account') ){
            this.ui.dropdowns.click(function(event){
                if (event.target.href) {
                    window.ga('send', 'pageview', event.target.href);
                } else {
                    window.ga('send', 'pageview', $(event.target).html());
                }
            });
        }
        if (globalCh.request('app_options', 'notifications')){
            this.show_notification_dropdown();
        }
    },
    setEmail: function(email) {
        this.model.set('email', email);
    },
    updateStatusCount: function(issue_count, severity) {
        if (issue_count > 0) {
            this.ui.status_count.text(issue_count);
            this.ui.status_count.removeClass('severity-severe severity-moderate severity-none');
            this.ui.status_count.addClass('severity-' + severity);
            this.ui.status_count.show();
        } else {
            this.ui.status_count.hide();
        }
    },
    //  updateUnassignedDevicesCount: function() {
    //     var primary = globalCh.request('primary_account');

    //     var unassigned_devices_primary = primary.devices.filter(function(device) {
    //          return !device.has('model_id');
    //     });

    //     this.ui.devices_primary_count.text(unassigned_devices_primary.length);
    //     this.unassigned_devices_primary_count = unassigned_devices_primary.length;

    //     if ( unassigned_devices_primary.length > 0 ) {
    //         this.ui.devices_primary_count.addClass('has-unassigned');
    //      } else {
    //         this.ui.devices_primary_count.removeClass('has-unassigned');
    //     }

    //  },
    show_profile_primary: function() {
        var primary = globalCh.request('primary_account');
        Radio.request('global', 'show_profile', primary);
    },

    show_primary_devices_list: function(e) {
        e.preventDefault();
        var primary = globalCh.request('primary_account');
        globalCh.request('changeActiveAccount', primary, ()=>{
            globalCh.request('set_selection', {
                type: 'app',
                id: 'devices',
            });
            globalCh.request('show_my_development_devices', primary);
        });
    },
    show_blinkup_page: function(e) {
        e.preventDefault();
        var primary = globalCh.request('primary_account');
        globalCh.request('changeActiveAccount', primary, () => {
            globalCh.request('set_selection', {
                type: 'app',
                id: 'blinkup',
            });
            globalCh.request('show_blinkup', primary);
        });
    },
    /**
     * Handle click logout button
     */
    doLogout: function(event) {
        event.stopPropagation();
        globalCh.request('logout');
    },
    onDestroy: function() {
        globalCh.off(null, null, this);
    },
    add_preview_popover: function(){
    var view = new PreviewPopover();
        /*
        * Options for the Popover
        */
        var popover_options = {
            link_title: strings.link_to_production,
            target : this.ui.preview_popover.find('a'),
            content : view
        };
        globalCh.request('addPopover', popover_options);
    },
    home: function() {
        globalCh.request('home');
    },
    show_notification_dropdown: function() {
        var self = this;
        const notifications = apiCh.request('notification');
        notifications.fetch()
        .done(function() {
            self.showChildView('notificationDropdown', new NotificationDropdownView({collection:notifications}));
        }).then( ()=>{
            this.listenTo(notifications, 'add remove mark_read', function() {
                self.showChildView('notificationDropdown', new NotificationDropdownView({collection:notifications}));
            });
        });
    },
});
export default TopNavView;

